export class ApiError extends Error {
  constructor(message, status) {
    super(message)
    this.status = status
  }
}

export async function api(path, options = {}) {
  const response = await fetch(path, {
    method: options.method || 'GET',
    credentials: 'same-origin',
    headers: options.body ? { 'content-type': 'application/json' } : undefined,
    body: options.body ? JSON.stringify(options.body) : undefined,
  })
  let data = null
  try { data = await response.json() } catch (error) { /* ignore */ }
  if (!response.ok) {
    throw new ApiError((data && data.error) || ('请求失败 ' + response.status), response.status)
  }
  return data
}

export const authApi = {
  me: () => api('/api/me'),
  login: (email, password) => api('/api/login', { method: 'POST', body: { email, password } }),
  register: (email, password) => api('/api/register', { method: 'POST', body: { email, password } }),
  logout: () => api('/api/logout', { method: 'POST' }),
}

export const docsApi = {
  list: () => api('/api/docs'),
  save: (id, kind, payload) => api('/api/docs', { method: 'PUT', body: { id, kind, payload } }),
  history: (id, limit = 50) => api('/api/docs/' + encodeURIComponent(id) + '/history?limit=' + limit),
  restore: (id, version) => api('/api/docs/' + encodeURIComponent(id) + '/restore', { method: 'POST', body: { version } }),
}
